import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useDispatch, useSelector } from 'react-redux';
import { selectedProposalPreparedByName } from '../../../../../features/gms-state-and-modal/state-slice';
import { IcRoundDownload } from '../../../../../assets/icon/iconify';
import { useFilesActions } from '../../../../../hooks/actions/use-files-actions';
import NotesPreview from '../../../../ui/notes-preview';
import { selectActNoteForCFE } from '../../../../../features/actuarial/remark-slice';
import ProposalPreviewDocuments from './proposal-preview-documents';
import { selectFileDocuments } from '../../../../../features/actuarial/document-slice';
import PreviewDetailsData from './preview-details-data';
import { selectAmendmentModal, selectSubAmendmentModal } from '../../../../../features/actuarial/request-amendment/request-amendment.slice';
import AmendmentHistoryLogs from '../amendment-history-logs';
import ProposalPreviewAmendments from './proposal-preview-amendments';
import { selectExistingCsvFilePath } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice';
import { selectProposalExpiredAt } from '../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import LoadingGlobal from '../../../../ui/loading-global';
import LoadingFile from '../../../../ui/loading-file';
import ProposalPreviewRequestExtensionContainer from './proposal-preview-request-extension-container';
import { useComputationActions } from '../../../../../hooks/actions/user-computation-actions';
import { useExtensionActions } from '../../../../../hooks/actions/use-extension-actions';
import ProposedProposalPreview from '../amend-proposal/proposed-proposal-preview';
import { setUpdateTypeModal } from '../../../../../features/gms-state-and-modal/modal-slice';

const SectionLabel = ({ label }: { label: string }) => (
    <div className="flex items-center gap-2 px-0.5 pt-1">
        <span className="whitespace-nowrap text-[9px] font-semibold uppercase tracking-wider text-gray-400 sm:text-[10px]">
            {label}
        </span>
        <div className="h-px flex-1 bg-gray-200" />
    </div>
);

export default function ProposalPreviewDataModal() {

    const dispatch = useDispatch();
    const subAmendmentModal = useSelector(selectSubAmendmentModal);
    const { isLoadingRequestProposalExtension } = useExtensionActions();
    const { 
        isLoadingDownloadSupportingDocuments, 
        isLoadingDownloadMasterAttachedFile, 
        isLoadingDownloadActDocuments 
    } = useFilesActions()
    const { 
        handleDownloadMasterFile, 
        handleDownloadSupportingDocumentsCFE, 
        handleDownloadSupportingDocumentsAct,
    } = useFilesActions();
    const { 
        isCustomize, 
        isHasAttachedFile,
        isMarketingGMSDepartment,
        isActuarialDepartment,
        contactPersonSalutation,
        contactPersonFirstName,
        contactPersonMiddleName,
        contactPersonLastName,
        groupName,
        email,
        natureOfBusinessCategory,
        proposalTypeState,
        proposalAs,
        prototype,
        product,
        filesCFE,
        isDraftProposal
    } = useProposalTypeData();
    const loadingGlobal = isLoadingRequestProposalExtension;
    const loadingDownloadFile = isLoadingDownloadMasterAttachedFile || isLoadingDownloadSupportingDocuments || isLoadingDownloadMasterAttachedFile || isLoadingDownloadActDocuments
    const amendmentModal = useSelector(selectAmendmentModal)
    const proposalPreparedBy = useSelector(selectedProposalPreparedByName);
    const existingCsvFilePath = useSelector(selectExistingCsvFilePath);
    const documentFilesOfActuarial = useSelector(selectFileDocuments);
    const noteForCFE = useSelector(selectActNoteForCFE);
    const middleInitial = contactPersonMiddleName ? `${contactPersonMiddleName.charAt(0)}.` : '';
    const contractPersonFormat = `${contactPersonSalutation ?? ''} ${contactPersonFirstName ?? ''} ${middleInitial} ${contactPersonLastName ?? ''}`.replace(/\s+/g, ' ').trim();
    const productName = isCustomize ? product?.name : prototype?.name;
    const actuarialAndMarketing = isMarketingGMSDepartment || isActuarialDepartment
    const expiry_date = useSelector(selectProposalExpiredAt);

    // const documentConfig = isActuarial
    //     ? {
    //         title: "Supporting documents",
    //         subtitle: "The documents below were provided by the CFE.",
    //         files: filesOfCFE,
    //         handleDownload: handleDownloadSupportingDocumentsCFE,
    //     } : isMKT_GMS ? {
    //         title: "Supporting documents",
    //         subtitle: "The documents below were uploaded by the Actuarial.",
    //         files: documentFilesOfActuarial,
    //         handleDownload: handleDownloadSupportingDocumentsAct,
    //     } : null;

    const documentConfig = isActuarialDepartment
        ? {
            title: "Supporting documents",
            subtitle: "The documents below were uploaded by the Actuarial.",
            files: documentFilesOfActuarial,
            handleDownload: handleDownloadSupportingDocumentsAct,
        }
        : isMarketingGMSDepartment
            ? {
                title: "Supporting documents",
                subtitle: "The documents below were uploaded by the CFE.",
                files: filesCFE,
                handleDownload: handleDownloadSupportingDocumentsCFE,
            }
            : null;

    const handleViewProposal = () => {
        dispatch(setUpdateTypeModal('showProposalDetails'))
        // your existing view proposal logic
    };

    const handleViewRates = () => {
        dispatch(setUpdateTypeModal('showComputationDetails'))
        // your existing view rates logic
    };

    return (
    <div className="flex h-full min-h-0 flex-col space-y-1">
        {/* ACTIONS */}
        <SectionLabel label="Actions" />
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <button type="button" onClick={handleViewProposal} disabled={isDraftProposal} className={`flex min-w-0 items-center gap-2 rounded-md border p-2 text-left transition ${isDraftProposal ? 'cursor-not-allowed border-gray-200 bg-gray-100 opacity-60' : 'border-gray-200 bg-gray-50/70 hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5'}`}>
                <div className={`border border-[#186cb2]/10 flex h-8 w-8 shrink-0 items-center justify-center rounded-md ${isDraftProposal ? 'bg-gray-200 text-gray-400' : 'bg-white text-[#186cb2]'}`}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4"><path strokeLinecap="round" strokeLinejoin="round" d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" /><circle cx="12" cy="12" r="2.5" /></svg>
                </div>
                <div className="min-w-0 flex-1">
                    <p className={`text-[11px] font-semibold ${isDraftProposal ? 'text-gray-400' : 'text-[#186cb2]'}`}>View Proposal</p>
                    <p className="mt-0.5 truncate text-[10px] text-gray-500">{isDraftProposal ? 'Unavailable while proposal is in draft' : 'Prepared by the CFE'}</p>
                </div>
                {!isDraftProposal && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-3.5 w-3.5 shrink-0 text-gray-400"><path strokeLinecap="round" strokeLinejoin="round" d="m9 18 6-6-6-6" /></svg>}
            </button>

            <button type="button" onClick={handleViewRates} disabled={isDraftProposal} className={`flex min-w-0 items-center gap-2 rounded-md border p-2 text-left transition ${isDraftProposal ? 'cursor-not-allowed border-gray-200 bg-gray-100 opacity-60' : 'border-gray-200 bg-gray-50/70 hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5'}`}>
                <div className={`border border-[#186cb2]/10 flex h-8 w-8 shrink-0 items-center justify-center rounded-md ${isDraftProposal ? 'bg-gray-200 text-gray-400' : 'bg-white text-[#186cb2]'}`}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4"><path strokeLinecap="round" strokeLinejoin="round" d="M4 19V5" /><path strokeLinecap="round" strokeLinejoin="round" d="M4 19h16" /><path strokeLinecap="round" strokeLinejoin="round" d="m7 15 4-4 3-2 5-6" /></svg>
                </div>
                <div className="min-w-0 flex-1">
                    <p className={`text-[11px] font-semibold ${isDraftProposal ? 'text-gray-400' : 'text-[#186cb2]'}`}>View Rates</p>
                    <p className="mt-0.5 truncate text-[10px] text-gray-500">{isDraftProposal ? 'Unavailable while proposal is in draft' : 'Submitted by the Actuarial team'}</p>
                </div>
                {!isDraftProposal && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-3.5 w-3.5 shrink-0 text-gray-400"><path strokeLinecap="round" strokeLinejoin="round" d="m9 18 6-6-6-6" /></svg>}
            </button>
        </div>

        {/* REQUEST / AMENDMENTS */}
        {actuarialAndMarketing && (
            <>
                {/* <SectionLabel label="Request & Amendments" /> */}

                {expiry_date && (
                    <ProposalPreviewRequestExtensionContainer expiryDate={expiry_date} />
                )}

                <ProposalPreviewAmendments />
            </>
        )}

        {/* ACTUARIAL NOTES */}
        {isMarketingGMSDepartment && noteForCFE?.length > 0 && (
            <>
                {/* <SectionLabel label="Actuarial Notes" /> */}

                <div className="rounded-lg border border-gray-200 bg-white p-2.5 shadow-sm sm:p-3">
                    <div className="mb-2 flex items-center gap-2">
                        <div className="border border-[#186cb2]/10 flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-[#186cb2]">
                            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3 2.5 20h19L12 3Z" /><path d="M12 9v5" /><path d="M12 17h.01" /></svg>
                        </div>
                        <div className="min-w-0 flex-1">
                            <p className="text-[11px] font-semibold text-[#186cb2]">Actuarial Notes</p>
                            <p className="truncate text-[10px] text-gray-500">Notes provided by the Actuarial team</p>
                        </div>
                    </div>

                    <NotesPreview content={noteForCFE} styleOne="p-2" />
                </div>
            </>
        )}

        {/* SUPPORTING DOCUMENTS */}
        {actuarialAndMarketing && (
            <>
                {/* <SectionLabel label="Supporting Documents" /> */}

                <div className="space-y-2">
                    <ProposalPreviewDocuments
                        title="Actuarial Documents"
                        subtitle="Documents uploaded by the Actuarial."
                        files={documentFilesOfActuarial}
                        handleDownload={handleDownloadSupportingDocumentsAct}
                        isLoading={loadingDownloadFile}
                    />

                    <ProposalPreviewDocuments
                        title="CFE Documents"
                        subtitle="Documents uploaded by the CFE."
                        files={filesCFE}
                        handleDownload={handleDownloadSupportingDocumentsCFE}
                        isLoading={loadingDownloadFile}
                    />
                </div>
            </>
        )}

        {/* PROPOSAL DETAILS */}
        <SectionLabel label="Proposal Details" />

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <PreviewDetailsData title={natureOfBusinessCategory?.name ?? ''} value={groupName} iconType={7} />
            <PreviewDetailsData title="Prepared by" value={proposalPreparedBy ?? ''} iconType={8} />
        </div>

        <div className="h-px bg-gray-200" />

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <PreviewDetailsData title="Contact Person" value={contractPersonFormat} iconType={1} />
            <PreviewDetailsData title="Email" value={email} iconType={3} />
        </div>

        <div className="h-px bg-gray-200" />

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <PreviewDetailsData title="Proposal as" value={proposalAs?.name ?? ''} iconType={5} />
            <PreviewDetailsData title="Proposal type" value={proposalTypeState?.name ?? ''} iconType={5} />
            <PreviewDetailsData title="Product" value={productName ?? ''} iconType={6} />

            {isCustomize && actuarialAndMarketing && isHasAttachedFile && existingCsvFilePath && (
                <div className="flex min-h-[52px] min-w-0 items-center gap-2 rounded-md border border-gray-200 bg-gray-50/70 p-2 transition hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-white text-[#186cb2]">
                        <div onClick={handleDownloadMasterFile} className={`${existingCsvFilePath ? 'cursor-pointer' : 'cursor-not-allowed'}`}>
                            <IcRoundDownload color="#186cb2" width={18} height={18} />
                        </div>
                    </div>

                    <div className="w-full min-w-0">
                        <p className="truncate text-[9px] font-medium uppercase tracking-wide text-gray-400 sm:text-[10px]">
                            Master list file
                        </p>
                        <p className="truncate text-xs font-medium text-gray-800">
                            {existingCsvFilePath || 'No master list attached'}
                        </p>
                    </div>
                </div>
            )}
        </div>

        {/* HISTORY */}
        {amendmentModal === 'showAmendmentHistory' && (
            <>
                <SectionLabel label="Amendment History" />
                <AmendmentHistoryLogs />
            </>
        )}

        {subAmendmentModal === 'viewProposedDataInHistory' && (
            <>
                <SectionLabel label="Proposed Data" />
                <ProposedProposalPreview />
            </>
        )}

        {loadingGlobal && <LoadingGlobal />}
        {loadingDownloadFile && <LoadingFile />}
    </div>
);
}
